import { render, staticRenderFns } from "./BindsListItemDefault.vue?vue&type=template&id=5d3f8060&"
import script from "./BindsListItemDefault.vue?vue&type=script&lang=js&"
export * from "./BindsListItemDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports